"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksConnectVendorDataCreate = exports.QuickbooksConnectVendorDataUpdate = exports.QuickbooksConnectVendorData = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.QuickbooksConnectVendorData = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    quickbooksSyncToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    quickbooksID: typebox_1.Type.Optional(typebox_1.Type.String()),
    quickbooksDisplayName: typebox_1.Type.String(),
    vendorCreatedAt: typebox_1.Type.String({ format: 'date-time' }),
    possibleMatches: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    lastUpdated: typebox_1.Type.String({ format: 'date-time' }),
    lastSynced: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    lastSyncError: typebox_1.Type.Optional(typebox_1.Type.String()),
    retrySyncAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
exports.QuickbooksConnectVendorDataUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.QuickbooksConnectVendorData, ['haulerID', 'id']));
exports.QuickbooksConnectVendorDataCreate = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    quickbooksDisplayName: typebox_1.Type.String(),
    vendorCreatedAt: typebox_1.Type.String({ format: 'date-time' }),
});
//# sourceMappingURL=vendor-data.js.map